'use strict';

module.exports = function (name) {
  if (!name) return name;

  name = name.split('__');
  name.shift();

  return name.join('__');
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/get-name.js